/**
 * Registry for nine navagraha study-sheet syllabus topics (5.2–5.10).
 */
import { GRAHA_GUIDE_ORDER } from './jyotishaGrahaGuides';
import { GRAHA_HI_EN_BY_EN } from './jyotishaGrahaNames';

const GRAHA_SLUG = {
  Sun: 'sun',
  Moon: 'moon',
  Mars: 'mars',
  Mercury: 'mercury',
  Jupiter: 'jupiter',
  Venus: 'venus',
  Saturn: 'saturn',
  Rahu: 'rahu',
  Ketu: 'ketu',
};

/** Sanskrit-style roman labels for tab titles */
const GRAHA_ROMAN = {
  Sun: 'Surya',
  Moon: 'Chandra',
  Mars: 'Mangal',
  Mercury: 'Budh',
  Jupiter: 'Guru',
  Venus: 'Shukra',
  Saturn: 'Shani',
  Rahu: 'Rahu',
  Ketu: 'Ketu',
};

/** @type {{ id: string; grahaKey: string; slug: string; hi: string; en: string; roman: string }[]} */
export const GRAHA_GUIDE_TOPICS = GRAHA_GUIDE_ORDER.map((grahaKey) => {
  const slug = GRAHA_SLUG[grahaKey];
  const names = GRAHA_HI_EN_BY_EN[grahaKey];
  const roman = GRAHA_ROMAN[grahaKey];
  return {
    id: `graha-${slug}`,
    grahaKey,
    slug,
    hi: names?.hi ?? grahaKey,
    en: names?.en ?? grahaKey,
    roman,
    tabHi: `${names?.hi ?? grahaKey} · ${roman}`,
    tabEn: `${names?.en ?? grahaKey} · ${roman}`,
  };
});

export const GRAHA_GUIDE_TOPIC_IDS = GRAHA_GUIDE_TOPICS.map((t) => t.id);

const TOPIC_BY_ID = Object.fromEntries(GRAHA_GUIDE_TOPICS.map((t) => [t.id, t]));
const TOPIC_BY_GRAHA_KEY = Object.fromEntries(GRAHA_GUIDE_TOPICS.map((t) => [t.grahaKey, t]));

/**
 * @param {string} topicId
 * @returns {string | null} grahaKey e.g. 'Sun'
 */
export function getGrahaKeyFromTopicId(topicId) {
  return TOPIC_BY_ID[topicId]?.grahaKey ?? null;
}

/**
 * @param {string} grahaKey
 * @returns {string | null} topicId e.g. 'graha-sun'
 */
export function getGrahaGuideTopicId(grahaKey) {
  return TOPIC_BY_GRAHA_KEY[grahaKey]?.id ?? null;
}

/**
 * @param {string} topicId
 */
export function getGrahaGuideTopic(topicId) {
  return TOPIC_BY_ID[topicId] ?? null;
}
